import { UserStatus } from "../../constants";

const UserActions = {
    ACTIVE: 1,
    INACTIVE: 0
};

export const getStatus = (status) =>
    // status === UserStatus.VERIFIED ? UserStatus.UNVERIFIED : UserStatus.VERIFIED;
    status === UserStatus.ACTIVE || status === UserStatus.UNVERIFIED
        ? UserStatus.INACTIVE
        : UserStatus.ACTIVE;

export const getStatusRunningOrCanceled = (status) =>
    // status === UserStatus.VERIFIED ? UserStatus.UNVERIFIED : UserStatus.VERIFIED;
    status === UserStatus.ACTIVE || status === UserStatus.UNVERIFIED
        ? UserStatus.ACTIVE
        : UserStatus.INACTIVE;

export const findStatusChecked = (status, name) => {
    return status === UserStatus.ACTIVE || status === UserStatus.UNVERIFIED
        ? UserActions.ACTIVE
        : UserActions.INACTIVE;
};

export const handleAdModal = (setState, state) => setState(!state);
